// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var FormField = function (x) {
    return x;
};
var Conversion = function (x) {
    return x;
};
var semigroupoidConversion = {
    compose: function (v) {
        return function (v1) {
            return {
                fromInitial: function ($126) {
                    return v.fromInitial(v1.fromInitial($126));
                },
                toFinal: (function () {
                    var $127 = Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(v1.toFinal);
                    return function ($128) {
                        return $127(v.toFinal($128));
                    };
                })()
            };
        };
    }
};
var phoneRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^\\+?[0-9 -]+$")(Data_String_Regex_Flags.noFlags));
var normalizeDecimalSeparator = function (s) {
    var $42 = Data_String_CodeUnits.contains(".")(s);
    if ($42) {
        return s;
    };
    return Data_String_Common.replace(",")(".")(s);
};
var nonNothingConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $43 = Data_Maybe.isNothing(x);
            if ($43) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var nonEmptyStringConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $44 = Data_String_Common["null"](Data_String_Common.trim(x));
            if ($44) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var nonEmptyArrayConversion = function (errorMessage) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $45 = Data_Foldable["null"](Data_Foldable.foldableArray)(x);
            if ($45) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
        }
    };
};
var noFieldState = {
    submitOccured: Specular_FRP_Base.never,
    remoteErrors: /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(/* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray))
};
var newFormFieldEDyn = function (dictMonadFRP) {
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Ref.newRef(dictMonadFRP.MonadEffect0())(initial))(function (ref) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Callback.newCallback(dictMonadFRP.MonadEffect0()))(function (focusOutCallback1) {
                        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(dictMonadFRP)(false)(Specular_FRP_Base.leftmost([ Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(focusOutCallback1.event), Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(remoteState.submitOccured) ])))(function (isTouched1) {
                            var toFinal = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                                return v.toFinal;
                            })(conversion);
                            return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())({
                                editRef: ref,
                                focusOutCallback: focusOutCallback1.callback,
                                finalValue: Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Function.apply)(toFinal))(Specular_Ref.refValue(ref)),
                                isTouched: isTouched1,
                                remoteState: remoteState
                            });
                        });
                    });
                });
            };
        };
    };
};
var newFormFieldE = function (dictMonadFRP) {
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldEDyn(dictMonadFRP)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(conversion))(remoteState)(initial);
            };
        };
    };
};
var newFormField = function (dictMonadFRP) {
    return function (v) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldE(dictMonadFRP)(v)(remoteState)(v.fromInitial(initial));
            };
        };
    };
};
var moneyRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]{2})?$")(Data_String_Regex_Flags.noFlags));
var maybeStringConversion = /* #__PURE__ */ (function () {
    var toFinal = function (v) {
        if (v === "") {
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
        };
        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(v));
    };
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: toFinal
    };
})();
var maybeConversion = function (errorMessage) {
    return {
        fromInitial: Data_Maybe.Just.create,
        toFinal: function (v) {
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 273, column 9 - line 275, column 46): " + [ v.constructor.name ]);
        }
    };
};
var isTouched = function (v) {
    return v.isTouched;
};
var intConversion = function (errorMessage) {
    return {
        fromInitial: Data_Show.show(Data_Show.showInt),
        toFinal: function (e) {
            var v = Data_Int.fromString(e);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 329, column 9 - line 331, column 27): " + [ v.constructor.name ]);
        }
    };
};
var intPercentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $59 = x >= 0 && x <= 100;
            if ($59) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var nonNegativeIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $63 = x >= 0;
            if ($63) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeIntError ]);
        }
    });
};
var positiveIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $67 = x > 0;
            if ($67) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveIntError ]);
        }
    });
};
var rangeIntConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(intConversion(v.intError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $71 = v.max >= x && x >= v.min;
            if ($71) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.rangeIntError ]);
        }
    });
};
var fromValidV = /* #__PURE__ */ (function () {
    return Data_Validation_Semigroup.validation(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Maybe.Just.create);
})();
var focusOutCallback = function (v) {
    return v.focusOutCallback;
};
var finalValueNoErr = function (v) {
    return Restaumatic_Form_Final.makeFinal(Data_Functor.map(Specular_FRP_Base.functorDynamic)(fromValidV)(v.finalValue));
};
var finalValue = function (v) {
    return v.finalValue;
};
var fieldStateEmpty = function (formState) {
    return {
        submitOccured: formState.submitOccured,
        remoteErrors: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Monoid.mempty(Data_Monoid.monoidArray))
    };
};
var errorsFromV = function (dictMonoid) {
    return Data_Validation_Semigroup.validation(Control_Category.identity(Control_Category.categoryFn))(function (v) {
        return Data_Monoid.mempty(dictMonoid);
    });
};
var emptyConversion = function (dictMonoid) {
    return function (dictEq) {
        return function (v) {
            return {
                fromInitial: Data_Maybe.maybe(Data_Monoid.mempty(dictMonoid))(v.fromInitial),
                toFinal: function (x) {
                    var $80 = Data_Eq.eq(dictEq)(x)(Data_Monoid.mempty(dictMonoid));
                    if ($80) {
                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
                    };
                    return Data_Functor.map(Data_Validation_Semigroup.functorV)(Data_Maybe.Just.create)(v.toFinal(x));
                }
            };
        };
    };
};
var emailRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data_String_Regex_Flags.noFlags));
var editRef = function (v) {
    return v.editRef;
};
var formFieldValue = function ($129) {
    return Specular_Ref.refValue(editRef($129));
};
var doesPhoneMatchRegex = /* #__PURE__ */ Data_String_Regex.test(phoneRE);
var maybePhoneConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $84 = Data_String_Common["null"](xt);
            if ($84) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
            };
            var $85 = doesPhoneMatchRegex(xt);
            if ($85) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var phoneConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $86 = doesPhoneMatchRegex(xt);
            if ($86) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var doesMoneyMatchRegex = /* #__PURE__ */ Data_String_Regex.test(moneyRE);
var moneyConversion = function (errorMessage) {
    return {
        fromInitial: Data_Money_Rounded.toString,
        toFinal: function (x) {
            var v = Data_Money_Rounded.fromString(normalizeDecimalSeparator(x));
            var v1 = doesMoneyMatchRegex(x);
            if (v1 && v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeMoneyConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(moneyConversion(v.moneyError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $91 = Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney)(x)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney));
            if ($91) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeMoneyError ]);
        }
    });
};
var positiveMoneyConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(moneyConversion(v.moneyError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $95 = Data_Ord.greaterThan(Data_Money_Rounded.ordMoney)(x)(Data_Numeric.zero(Data_Money_Rounded.additiveMoney));
            if ($95) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveMoneyError ]);
        }
    });
};
var doesEmailMatchRegex = /* #__PURE__ */ Data_String_Regex.test(emailRE);
var emailConversion = function (errorMsg) {
    return {
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $98 = doesEmailMatchRegex(xt);
            if ($98) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var maybeEmailConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $99 = Data_String_Common["null"](xt);
            if ($99) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(Data_Maybe.Nothing.value);
            };
            var $100 = doesEmailMatchRegex(xt);
            if ($100) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var displayedErrors = function (v) {
    return Control_Apply.lift3(Specular_FRP_Base.applyDynamic)(function ($$final) {
        return function (remote) {
            return function (isTouched$prime) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)((function () {
                    if (isTouched$prime) {
                        return errorsFromV(Data_Monoid.monoidArray)($$final);
                    };
                    return [  ];
                })())(remote);
            };
        };
    })(v.finalValue)(v.remoteState.remoteErrors)(v.isTouched);
};
var decimalRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]+)?$")(Data_String_Regex_Flags.noFlags));
var doesNumberMatchRegex = /* #__PURE__ */ Data_String_Regex.test(decimalRE);
var numberConversion = function (errorMessage) {
    return {
        fromInitial: Data_Show.show(Data_Show.showNumber),
        toFinal: function (e) {
            var v = Data_Number.fromString(normalizeDecimalSeparator(e));
            var v1 = doesNumberMatchRegex(e);
            if (v1 && v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeNumberConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $107 = x >= 0.0;
            if ($107) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeNumError ]);
        }
    });
};
var percentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $111 = x >= 0.0 && x <= 100.0;
            if ($111) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var positiveNumberConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $115 = x > 0.0;
            if ($115) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveNumError ]);
        }
    });
};
var categoryConversion = {
    identity: {
        fromInitial: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
        toFinal: /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))
    },
    Semigroupoid0: function () {
        return semigroupoidConversion;
    }
};
var atPath = function (path) {
    var $130 = Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray));
    var $131 = Data_Map_Internal.lookup(Data_Ord.ordArray(Data_Ord.ordString))(path);
    return function ($132) {
        return $130($131($132));
    };
};
var fieldState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: Data_Functor.map(Specular_FRP_Base.functorDynamic)(atPath(path))(formState.remoteErrors)
        };
    };
};
var arrayStripPrefix = function (dictEq) {
    return function (prefix) {
        return function (input) {
            var $118 = Data_Eq.eq(Data_Eq.eqArray(dictEq))(Data_Array.take(Data_Array.length(prefix))(input))(prefix);
            if ($118) {
                return new Data_Maybe.Just(Data_Array.drop(Data_Array.length(prefix))(input));
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var stripPathPrefix = function (prefix) {
    var strip = function (v) {
        return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create)(arrayStripPrefix(Data_Eq.eqString)(prefix)(v.value0)))(Control_Applicative.pure(Data_Maybe.applicativeMaybe)(v.value1));
    };
    var $133 = Data_Map_Internal.fromFoldable(Data_Ord.ordArray(Data_Ord.ordString))(Data_Foldable.foldableArray);
    var $134 = Data_Array.mapMaybe(strip);
    var $135 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    return function ($136) {
        return $133($134($135($136)));
    };
};
var focusFormState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: Data_Functor.map(Specular_FRP_Base.functorDynamic)(stripPathPrefix(path))(formState.remoteErrors)
        };
    };
};
var anyPercentageConversion = function (v) {
    return Control_Semigroupoid.compose(semigroupoidConversion)(numberConversion(v.numError))({
        fromInitial: Control_Category.identity(Control_Category.categoryFn),
        toFinal: function (x) {
            var $123 = x >= Data_Numeric.negate(Data_Numeric.additiveNumber)(100.0) && x <= 100.0;
            if ($123) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray))(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
export {
    FormField,
    Conversion,
    newFormField,
    newFormFieldE,
    newFormFieldEDyn,
    fieldState,
    fieldStateEmpty,
    focusFormState,
    noFieldState,
    editRef,
    isTouched,
    focusOutCallback,
    formFieldValue,
    displayedErrors,
    finalValue,
    finalValueNoErr,
    stripPathPrefix,
    atPath,
    maybeConversion,
    nonEmptyArrayConversion,
    moneyConversion,
    nonNegativeMoneyConversion,
    positiveMoneyConversion,
    intConversion,
    nonNegativeIntConversion,
    positiveIntConversion,
    rangeIntConversion,
    numberConversion,
    nonNegativeNumberConversion,
    positiveNumberConversion,
    anyPercentageConversion,
    percentageConversion,
    intPercentageConversion,
    emailConversion,
    maybeEmailConversion,
    phoneConversion,
    maybePhoneConversion,
    maybeStringConversion,
    nonEmptyStringConversion,
    emptyConversion,
    nonNothingConversion,
    semigroupoidConversion,
    categoryConversion
};
export {
    Final,
    bindFinal,
    invalidFinal,
    liftDynamic,
    liftMaybe,
    makeFinal,
    unFinal
} from "../Restaumatic.Form.Final/index.js";
//# sourceMappingURL=index.js.map
